<template>
    <b-form-group>
        <template slot="label">
            <span>{{ $tc('values.network.network', 1) }}</span>
        </template>
        <multiselect
            multiple
            :selected="model"
            :options="options"
            open-direction="top"
            @changeValue="$emit('update:model', $event)"
            :placeholder="$t('form.placeholder.selectSomeNetwork')"
        />
    </b-form-group>
</template>
<script>
import i18n from '@/i18n'
import { Multiselect } from '@/views/components/selects'
export default {
    components: {
        Multiselect,
    },
    props: {
        model: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            options: [
                {
                    value: 'team',
                    label: i18n.t('values.table.team'),
                },
                {
                    value: 'leader',
                    label: i18n.t('values.table.leader'),
                },
                {
                    value: 'peer',
                    label: i18n.t('values.table.peer'),
                },
                {
                    value: 'self',
                    label: i18n.t('values.table.self'),
                },
            ],
        }
    },
}
</script>
